import { defineStore } from 'pinia';
import { reqGetChannelProList } from '@/api/list';
import {
  // useCitySearch,
  lazyAMapApiLoaderInstance,
  useGeolocation,
} from '@vuemap/vue-amap';
// import AMapLoader from '@amap/amap-jsapi-loader';
interface PositioningState {
  province: string; // 地方频道选中的身份
  provinceCode: string; // 地方 频道的code
  provinceSelect: string; //地方 频道定位的身份
  firstChange: number;
  isCancel: boolean; // 是否取消/确认定位
  provinceList: Awaited<ReturnType<typeof reqGetChannelProList>>['data']; // 地方 频道的省份列表
  mapProvinces: string; // 地图选择的省份code
  mapPrivincesName: string; // 地图选择的省份名称
  myLngLat: string[]; // 地图定位的经纬度  [lng,lat]
  adcode: string;
  locationAddress: string; // 当前定位的位置地点
}

const usePositioningStore = defineStore('KePuPositioning', {
  state: (): PositioningState => ({
    province: '',
    provinceCode: '',
    provinceSelect: '',
    firstChange: 0,
    isCancel: false,
    provinceList: [],
    mapProvinces: '',
    mapPrivincesName: '',
    myLngLat: [], //116.373082, 39.878074
    adcode: '',
    locationAddress: '',
  }),
  actions: {
    /**
     * 定位信息
     *
     */
    resetPositioning() {
      this.$reset();
    },

    async setPositioning() {
      const localtionCityIp = await lazyAMapApiLoaderInstance
        .then(() => {
          return useGeolocation({
            enableHighAccuracy: true,
            needAddress: true,
          }).then((res) => {
            const { getCurrentPosition } = res;

            // getCityInfo().then((cityResult) => {
            //   console.log('cityResult: ', cityResult);
            // }) ;

            return getCurrentPosition().then((currentPosition) => {
              console.log('currentPosition: ', currentPosition);
              if (currentPosition.info === 'SUCCESS') {
                // 查询成功，cityResult即为当前所在城市信息 第一次定位进行赋值
                if (this.firstChange == 0) {
                  this.province = currentPosition.addressComponent.province;
                  this.provinceSelect =
                    currentPosition.addressComponent.province;
                  this.firstChange++;
                }
                return {
                  tablist: this.getTabar(),
                  geographic: currentPosition.addressComponent,
                  error: false,
                };
              } else {
                console.log(currentPosition);
                return {
                  tablist: this.getTabar(),
                  geographic: '',
                  error: true,
                };
              }
            });
          });
        })
        .catch(() => {
          return {
            tablist: this.getTabar(),
            geographic: '',
            error: true,
          };
        });
      return localtionCityIp;

      // const localtionCityIp = await lazyAMapApiLoaderInstance
      //   .then(() => {
      //     console.log(11);
      //     return useCitySearch();
      //   })
      //   .then(
      //     (res: {
      //       getLocalCity: () => Promise<{ info: string; province: string }>;
      //     }) => {
      //       console.log(22);
      //       const { getLocalCity } = res;
      //       return getLocalCity();
      //     }
      //   )
      //   .then((cityResult: { info: string; province: string }) => {
      //     console.log(33);
      //     if (cityResult.info === 'OK') {
      //       // 查询成功，cityResult即为当前所在城市信息 第一次定位进行赋值
      //       console.log(cityResult);
      //       if (this.firstChange == 0) {
      //         this.province = cityResult.province;
      //         this.provinceSelect = cityResult.province;
      //         this.firstChange++;
      //       }
      //       return {
      //         tablist: this.getTabar(),
      //         geographic: cityResult,
      //         error: false,
      //       };
      //     } else {
      //       console.log(44, cityResult);
      //       return {
      //         tablist: this.getTabar(),
      //         geographic: '',
      //         error: true,
      //       };
      //     }
      //   })
      //   .catch((e: string) => {
      //     console.log(55);
      //     console.log(e);
      //     return {
      //       tablist: this.getTabar(),
      //       geographic: '',
      //       error: true,
      //     };
      //   });
      // return localtionCityIp;
      // return new Promise((resolve, reject) => {
      //   lazyAMapApiLoaderInstance.then(() => {
      //     console.log(123);
      //     useCitySearch()
      //       .then((res) => {
      //         console.log(456);
      //         const { getLocalCity } = res;
      //         getLocalCity().then((cityResult) => {
      //           console.log('cityResult: ', cityResult);

      //           if (cityResult.info === 'OK') {
      //             // 查询成功，cityResult即为当前所在城市信息 第一次定位进行赋值
      //             if (that.firstChange == 0) {
      //               that.province = cityResult.province;
      //               that.provinceSelect = cityResult.province;
      //               that.firstChange++;
      //             }
      //             resolve({
      //               tablist: that.getTabar(),
      //               geographic: cityResult,
      //               error: false,
      //             });
      //           } else {
      //             resolve({
      //               tablist: that.getTabar(),
      //               geographic: '',
      //               error: true,
      //             });
      //           }
      //         });
      //       })
      //       .catch((e) => {
      //         console.log(e);
      //       });
      //   });
      // });

      // AMapLoader.load({
      //   key: '584e92a9c12c0b27cb849ae722e5d1e6', // 申请好的Web端开发者Key，首次调用 load 时必填
      //   version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      //   plugins: ['AMap.CitySearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      // })
      //   .then((AMap) => {
      //     const citySearch = new AMap.CitySearch();
      //     citySearch.getLocalCity(
      //       (
      //         status: string,
      //         result: {
      //           province: string;
      //           info: string;
      //           adcode: string;
      //         }
      //       ) => {
      //         if (status === 'complete' && result.info === 'OK') {
      //           // 查询成功，result即为当前所在城市信息 第一次定位进行赋值
      //           if (that.firstChange == 0) {
      //             that.province = result.province;
      //             that.provinceSelect = result.province;
      //             that.firstChange++;
      //           }
      //           resolve({
      //             tablist: that.getTabar(),
      //             geographic: result,
      //             error: false,
      //           });
      //         } else {
      //           resolve({
      //             tablist: that.getTabar(),
      //             geographic: '',
      //             error: true,
      //           });
      //         }
      //       }
      //     );
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
    },
    async setDefProvince() {
      const res = await reqGetChannelProList();
      this.provinceList = res?.data ?? [];
      // this.provinceList = [
      //   ...this.provinceList,
      //   { name_val: '北京市', province_code: 11000000000 },
      // ];
    },
    getTabar() {
      const tabar: {
        id: string;
        path: string;
        name: string;
        status: number;
        shenceEventName: string;
      }[] = [
        {
          id: 'follow',
          name: '关注',
          path: '/interest',
          status: 1,
          shenceEventName: 'M_KepuchinaFollowClick',
        },
        {
          id: 'top',
          name: '头条',
          path: '/headline',
          status: 1,
          shenceEventName: 'M_KepuchinaHeadlineClick',
        },
        {
          id: 'recommend',
          name: '推荐',
          path: '/recommendation',
          status: 1,
          shenceEventName: 'M_KepuchinaRecommendClick',
        },
        {
          id: 'local',
          name: '地方',
          path: '/channel/home',
          status: 1,
          shenceEventName: 'M_KepuchinaRegionClick',
        },
        {
          id: 'zhuanti',
          name: '热词解读',
          path: 'https://h5.kepuchina.cn/special/specialnew?id=AR202506272036390487&member_id=ME201606061612501109&check_code=43605e3fbfad282d445097469a62f9a2',
          status: 2,
          shenceEventName: 'M_KepuchinaHotWordsClick',
        },
        {
          id: 'ai',
          name: 'AI小科',
          path: '/ai/index',
          status: 1,
          shenceEventName: 'M_KepuchinaAIScienceClick',
        },
        {
          id: 'my',
          name: '我的',
          path: '/clienthome',
          status: 1,
          shenceEventName: 'M_KepuchinaMineClick',
        },
      ];
      if (this.province) {
        // 根据provinceSelect
        const result = this.provinceList.find(
          (item) => item.name_val == this.provinceSelect
        );
        if (result) {
          const local = tabar.find((item) => item.id == 'local');
          if (local) {
            local.name = result.sort_name;
          }
          this.setData({
            province: result.name_val,
            provinceCode: result.province_code,
          });
        } else {
          const local = tabar.find((item) => item.id == 'local');
          if (local) {
            local.name = '地方';
          }
          this.setData({
            province: this.provinceList[0].name_val,
            provinceCode: this.provinceList[0].province_code,
          });
        }
      }
      return tabar;
    },
    setData(data: { province?: string; provinceCode: string }) {
      const { province, provinceCode } = data;
      this.province = province || '';
      this.provinceCode = provinceCode;
    },
    setDataPosition(data: { mapProvinces: string; mapPrivincesName: string }) {
      const { mapProvinces, mapPrivincesName } = data;
      console.log(data);
      this.mapProvinces = mapProvinces;
      this.mapPrivincesName = mapPrivincesName;
    },
    setmyLngLat(data: string[]) {
      this.myLngLat = data;
    },
    setAdCode(data: string) {
      this.adcode = data;
    },
    setLocationAddress(data: string) {
      this.locationAddress = data;
    },
  },
  persist: {
    key: 'KePuPositioning', //自定义存储名称
    storage: sessionStorage, //自定义存储位置
  },
});

export default usePositioningStore;
